<div class="rating-stars">
    <!-- *ngFor="let ratingId of ratingArr; index as i" -->
    @for (itemValue of ratings; track $index) {
        <button
            class="rating-star-button"
            mat-icon-button
            [id]="'star_'+ $index"
            [color]="color"
            (click)="onClick($index + 1)"
            [matTooltip]="itemValue"
            matTooltipPosition="below">
            <mat-icon [color]="color">
                {{ ($index < rating()) ? 'star': 'star_border' }}
                <!-- {{ ~getIcon(i) }} -->
            </mat-icon>
        </button>
    }
</div>
